import './pollyfills'
import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app'
import { ConfigProvider } from './config'
// import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root')

if (rootElement) {
  const root = createRoot(rootElement)

  root.render(
    <StrictMode>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </StrictMode>,
  )
} else {
  console.error('Root not found')
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
